<template>
  <div class="covid-notice" v-show="!isHidden">
    <div class="content">
      <p class="notice" v-if="!isMobile">
        Konferencija je organizirana u skladu s epidemiološkim mjerama. Poštivanje razmaka, redovito korištenje
        dezinficijensa i nošenje maski je obavezno za sve sudionike.
      </p>
      <p class="notice mobile" @click="toggleModal" v-if="isMobile">Saznaj više o epidemiološkim mjerama.</p>
    </div>
    <CovidModal v-if="isModalAcitve" @close="toggleModal" />
  </div>
</template>

<script>
import { deviceHandling } from '@/mixins.js';

import CovidModal from './CovidModal';

export default {
  name: 'CovidNotice',
  mixins: [deviceHandling],
  components: {
    CovidModal,
  },
  props: {
    isHidden: Boolean,
  },
  data() {
    return {
      isModalAcitve: false,
    };
  },
  methods: {
    toggleModal() {
      this.isModalAcitve = !this.isModalAcitve;

      const body = document.querySelector('body');

      if (this.isModalAcitve) {
        body.style.height = '100%';
        body.style.overflow = 'hidden';
      } else {
        body.style.height = null;
        body.style.overflow = null;
      }
    },
  },
};
</script>

<style scoped>
.covid-notice {
  background-color: #162426;
}

.content {
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 200px;
  padding-right: 200px;
  max-width: 1440px;
  margin: auto;
}

.notice {
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
}

.notice.mobile {
  text-align: center;
  text-decoration: underline;
}

@media screen and (max-width: 1024px) {
  .content {
    padding-left: 140px;
    padding-right: 140px;
  }
}

@media screen and (max-width: 768px) {
  .content {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
